import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
import CenterTop from '@/components/layout/CenterTop.vue';
var NotFoundView = /*#__PURE__*/function (_Vue) {
  function NotFoundView() {
    _classCallCheck(this, NotFoundView);
    return _callSuper(this, NotFoundView, arguments);
  }
  _inherits(NotFoundView, _Vue);
  return _createClass(NotFoundView);
}(Vue);
NotFoundView = __decorate([Options({
  components: {
    CenterTop: CenterTop,
    NumberAnimation: NumberAnimation,
    MainTitle: MainTitle
  }
})], NotFoundView);
export default NotFoundView;